import { useRequestLogsSelectionStore } from "../request-logs-selection-context";

import {
  collectCurrentPageRowIds,
  collectLoadedRowIds,
  collectLoadedSelectedRowIds,
  getRequestRowId,
} from "./selectionHelpers";
import type { RequestRow } from "./requestLogGridTypes";

import { createGridSelectionCells } from "@/components/ui/ag-grid-table";

const { SelectionCheckboxCellRenderer, SelectionHeaderRenderer } = createGridSelectionCells<
  number,
  RequestRow
>({
  useSelectionStore: useRequestLogsSelectionStore,
  getRowId: getRequestRowId,
  helpers: {
    collectLoadedRowIds,
    collectCurrentPageRowIds,
    collectLoadedSelectedRowIds,
  },
});

export { SelectionCheckboxCellRenderer, SelectionHeaderRenderer };
